import * as React from 'react';
import { Image } from '@cian/ui-kit';

import * as styles from './styles.css';

export const ReportCard: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Image
        src="https://static.cdn-cian.ru/frontend/e2e-legal-check-assets/images/legal_check_promo_report.png"
        alt="Пример отчёта"
      />
    </div>
  );
};

ReportCard.displayName = 'ReportCard';
